module.exports = __webpack_public_path__ + "img/rr-plagas.35df7392.png";